import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { interactionsActions, searchTableActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class Interactions extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newInteraction, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Interações'}
          classes={classes}
          newResource={newInteraction}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'interacoes'}
        />

        <EditModal open={modalOpen} onClose={closeModal} />

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.interactions.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsActions.closeModal())
    },
    newInteraction: interaction => {
      dispatch(interactionsActions.newFormInteraction(interaction))
    },
    resetState: () => {
      dispatch(interactionsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(Interactions))



// WEBPACK FOOTER //
// ./src/containers/Interactions/index.js